<script setup lang="ts">
import { onMounted } from 'vue';

const MODE = import.meta.env.MODE

const stagingGtmScript = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-M74JNC6X"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`

const ppdGtmScript = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-55QGBMM7"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`

const prodGtmScript = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N9GCVQS6"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`

let gtmScript = ''
if (MODE === 'stagingv2') {
  gtmScript = stagingGtmScript
} else if (MODE === 'production') {
  gtmScript = prodGtmScript
} else if (MODE === 'preproduction') {
  gtmScript = ppdGtmScript
} else {
  gtmScript = stagingGtmScript
}

onMounted(() => {
  if (!document.getElementById('gtm-noscript')) {
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    noscript.innerHTML = gtmScript;
    document.body.prepend(noscript);
  }

  const hasConsent = typeof localStorage !== 'undefined' && localStorage.getItem('cookie-consent') === 'yes';
  if (typeof window !== 'undefined' && hasConsent) {
        // @ts-ignore
        if (typeof window.gtag === 'function') {
            // @ts-ignore
            window.gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        }
    }
})
</script>

<template>
  <slot />
</template>

<style scoped>
</style>
